import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from "./Dialog";

interface DialogConfirmationProps {
    children?: React.ReactNode;
    title: string;
    description: string;
    onConfirm: () => void;
    onCancel: () => void;
    isOpen: boolean;
    confirmText?: string;
    cancelText?: string;
}

export default function DialogConfirmation({ children, title, description, onConfirm, onCancel, isOpen, confirmText, cancelText }: DialogConfirmationProps) {
    return (
        <Dialog open={isOpen} onOpenChange={(open) => {
            if (!open) onCancel();
        }}>
            <div 
                className="z-[2001] screen-cover flex bg-black bg-opacity-50" 
                tabIndex={-1}
            >
                <DialogContent>
                    <DialogHeader>
                        <DialogTitle>{title}</DialogTitle>
                        <DialogDescription>{description}</DialogDescription>
                    </DialogHeader>
                    <div className="z-[2002] flex flex-grow flex-col sm:flex-grow-0 sm:flex-shrink sm:flex-row justify-end place-items-center pb-8 mb-6 mt-auto space-y-2 sm:space-y-0 sm:space-x-2 sm:flex sm:justify-end sm:place-items-end sm:mb-0">
                        <button className='btn-primary w-full sm:w-fit py-2 px-4 sm:place-self-end bg-warning-red' onClick={onConfirm}>
                            {confirmText || 'Delete'}
                        </button>
                        <button className='btn-secondary w-full sm:w-fit py-2 px-4 sm:place-self-end' onClick={onCancel}>
                            {cancelText || 'Cancel'}
                        </button>
                    </div>
                </DialogContent>
            </div>
        </Dialog>
    );
}